import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { syncAdGroups } from '../actions/GroupMenuActions';
import { IGroupInfo } from '../models/IGroupInfo';

export const SyncActiveDirectoryGroupsAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.SynchronizeGroups,
  translateName: Messages.synchronize_action,
  isVisible: (targetItems: IGroupInfo[], state: AppState) => {
    return targetItems.length >= 1
      && SessionUserSelectors.canManageUsers(state)
      && hasADGroups(targetItems);
  },
  isClickable: () => true,
  createReduxAction: (targetItems: IGroupInfo[]) => syncAdGroups(targetItems)
};

function hasADGroups(groups: IGroupInfo[]): boolean {
  const result = groups.filter(group => isActiveDirectoryGroup(group)).length;
  return result >= 1;
}

function isActiveDirectoryGroup(group: IGroupInfo): boolean {
  return (group.domainName && group.domainName !== 'local');
}
